import React from 'react';
import PropTypes from 'prop-types'

import { StandardButton } from '../../shared'
import { MONTHLY_RATE_LARGE } from '../../constants'

import css from './Reservation.module.scss'

const UnitTable = ({selectedRow, clickHandler}) => {
  return (
    <table className={css.table}>
      <thead>
        <tr>
          <th className={css.tableHead}>Type</th>
          <th className={css.tableHead}>Size</th>
          <th className={css.tableHead}>Climate Controlled</th>
          <th className={css.tableHead}>Monthly Rate</th>
          <th className={css.tableHead} />
        </tr>
      </thead>
      <tbody>
        <tr className={selectedRow === 1 ? css.selected : null}>
          <td className={css.tableData}>Self Storage</td>
          <td className={css.tableData}>5 x 10</td>
          <td className={css.tableData}>No</td>
          <td className={css.tableData}>$60</td>
          <td className={css.tableData}><StandardButton text={selectedRow === 1 ? "Selected" : "Select"} type="link" clickHandler={() => clickHandler(1)}/></td>
        </tr>
        <tr className={selectedRow === 2 ? css.selected : null}>
          <td className={css.tableData}>Self Storage</td>
          <td className={css.tableData}>10 x 10</td>
          <td className={css.tableData}>No</td>
          <td className={css.tableData}>$85</td>
          <td className={css.tableData}><StandardButton text={selectedRow === 2 ? "Selected" : "Select"} type="link" clickHandler={() => clickHandler(2)}/></td>
        </tr>
        <tr className={selectedRow === 3 ? css.selected : null}>
          <td className={css.tableData}>Self Storage</td>
          <td className={css.tableData}>10 x 15</td>
          <td className={css.tableData}>No</td>
          <td className={css.tableData}>{`$${MONTHLY_RATE_LARGE}`}</td>
          <td className={css.tableData}><StandardButton text={selectedRow === 3 ? "Selected" : "Select"} type="link" clickHandler={() => clickHandler(3)}/></td>
        </tr>
      </tbody>
    </table>
  )
}

UnitTable.propTypes = {
  selectedRow: PropTypes.number,
  clickHandler: PropTypes.func
}

UnitTable.defaultProps = {
  selectedRow: 0,
  clickHandler: Function.prototype
}

export default UnitTable;
